<template>
  <transition name="modal">
    <div class="modal">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div v-if="header" class="fs-lg fw-bold modalHeader">
            {{ header }}
          </div>

          <div class="modal-body">
            <p style="font-size:1rem;">{{ body }}</p>
          </div>

          <div class="modal-footer">
            <div class="buttons">
              <Button
                v-on:button-click="$emit('confirm')"
                type="button"
                bType="error"
                class="modalButton"
              >
                {{ okText }}
              </Button>
              <Button
                v-on:button-click="$emit('cancel')"
                type="button"
                bType="secondary"
                class="modalButton2"
              >
                {{ cancelText }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Button from '@/components/DesignSystem/Button';

export default {
  name: 'Modal',
  components: {
    Button,
  },
  props: {
    header: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
    okText: {
      type: String,
      default: 'Ok',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
  },
};
</script>

<style lang="scss">
.modal {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: all 0.3s ease;
  opacity: 1;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 95%;
  max-width: 420px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-body {
  margin: 20px 0;
}

.buttons {
  text-align: right;
  font-size: 14px;
}
.modalButton {
  margin-right: 8px !important;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
  opacity: 1;
}

.modalHeader {
  text-transform: lowercase;
}
.modalHeader::first-letter {
  text-transform: capitalize;
}
</style>
